import React from "react"

interface EOTabTitleProps {
    id: string
    icon: string
    label: React.ReactNode
}

const EOTabTitle: React.FC<EOTabTitleProps> = ({ id, icon, label }) => (
    <div id={id}>
        <span className="material-icons">{icon}</span>
        {label}
    </div>
)

export default EOTabTitle
